<template>
  <el-dialog
    v-model="showNicknameDialog"
    title="修改昵称"
    width="min(480px, 92vw)"
    destroy-on-close
    @closed="resetNicknameDialog"
  >
    <el-input
      v-model="nicknameInput"
      maxlength="20"
      show-word-limit
      placeholder="请输入昵称"
      @keyup.enter="submitNickname"
    />
    <template #footer>
      <el-button @click="showNicknameDialog = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitNickname">
        保存
      </el-button>
    </template>
  </el-dialog>

  <el-dialog
    v-model="showPhoneDialog"
    title="更换手机号"
    width="min(480px, 92vw)"
    destroy-on-close
    @closed="resetPhoneDialog"
  >
    <div class="profile-phone-form">
      <div class="profile-phone-form__row">
        <span class="profile-phone-form__label">新手机号</span>
        <el-input
          v-model="newPhone"
          maxlength="11"
          placeholder="请输入新手机号"
        />
      </div>
      <div class="profile-phone-form__row">
        <span class="profile-phone-form__label">验证码</span>
        <el-input
          v-model="phoneCode"
          maxlength="6"
          placeholder="请输入验证码"
        />
        <el-button
          class="profile-phone-form__code-btn"
          :disabled="countdown > 0"
          @click="sendPhoneCode"
        >
          {{ countdown > 0 ? `${countdown}s` : "获取验证码" }}
        </el-button>
      </div>
    </div>
    <template #footer>
      <el-button @click="showPhoneDialog = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="submitPhone">
        确认更换
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { useProfileEdit } from "@/composables/useProfileEdit.js";

const {
  showNicknameDialog,
  showPhoneDialog,
  nicknameInput,
  newPhone,
  phoneCode,
  submitting,
  countdown,
  openNicknameDialog,
  openPhoneDialog,
  resetNicknameDialog,
  resetPhoneDialog,
  submitNickname,
  sendPhoneCode,
  submitPhone,
} = useProfileEdit();

/* eslint-disable-next-line no-undef */
defineExpose({
  openNicknameDialog,
  openPhoneDialog,
});
</script>

<style lang="scss" scoped>
.profile-phone-form__row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
}

.profile-phone-form__label {
  flex-shrink: 0;
  width: 72px;
  font-size: 15px;
  color: var(--ux-text-secondary, #9fb4d6);
}

.profile-phone-form__code-btn {
  flex-shrink: 0;
  min-width: 108px;
}
</style>
